export const environment = {
  production: true,
  domainName: window.location.hostname,
  apiUrl: 'https://' + window.location.hostname + '/proxy',
  helpUrl: 'https://help.papertrl.com/',
  vendorCommunityUrl: 'https://vendors.papertrl.com/#/',
  exusPartner: 'exus',
  demoEnv: false,
  gtag: 'G-KG27KEFQTP',
  env: 'Production',
  auth: {
    domain: 'papertrl.us.auth0.com',
    clientId: 'c4rq5fxOA3m04GMSuQrRdpvuCs0NCw2R',
    authorizationParams: {
      audience: 'https://papertrl.us.auth0.com/api/v2/',
      redirect_uri: window.location.origin + '/callback',
      scope: 'openid profile email offline_access'
    }
  }
};
